import {  OnInit } from '@angular/core';
import {Component, Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';



@Component({
  selector: 'app-dialog-toolbar',
  templateUrl: './dialog-toolbar.component.html',
  styleUrls: ['./dialog-toolbar.component.scss']
})
export class DialogToolbarComponent implements OnInit {

  buttonValue:string;

  constructor(
    public dialogRef: MatDialogRef<DialogToolbarComponent>) {}

  /**
   * Close modal with 'edit' value
   * */
  onEdit(): void {
     
    this.dialogRef.close('edit');
  }


/**
* Close modal with 'logout' value
* */
  onDelete(): void {
    
    this.dialogRef.close('logout');
  }


  ngOnInit(){

  }
}
